import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import UserActions from '../Redux/UserRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * getUser (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getUser, token, action.filter)
      if (!res.ok) {
        yield put(UserActions.userFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const data_with_page = {
            data: res.data.data,
            page,
            total
          }
          yield put(UserActions.userSuccess(data_with_page))
        } else {
          yield put(UserActions.userFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(UserActions.userFailure())
  }
}

export function * getUserCount (api, action) {
  yield baseFetchToken(api.getUserCount,
    action.filter,
    getToken,
    UserActions.userCountSuccess,
    UserActions.userCountFailure)
}

export function * createUser (api, action) {
  yield baseFetchToken(api.createUser,
    action.data,
    getToken,
    UserActions.userCreateSuccess,
    UserActions.userCreateFailure)
}

export function * updateUser (api, action) {
  yield baseFetchToken(api.updateUser,
    action.data,
    getToken,
    UserActions.userUpdateSuccess,
    UserActions.userUpdateFailure)
}

export function * deleteUser (api, action) {
  yield baseFetchToken(api.deleteUser,
    action.id,
    getToken,
    UserActions.userDeleteSuccess,
    UserActions.userDeleteFailure)
}

export function * downloadUserList (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.downloadUserList, token, action.data)
      if (!res.ok) {
        yield put(downloadUserList.userListFailure('Failed'))
      } else {
        if (!res.data.error) {
          yield put(UserActions.userListSuccess(res.data))
        } else {
          yield put(UserActions.userListFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(UserActions.userListFailure())
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/UserSagas.js